// Spec 084 — tipos canônicos das características de batelada (1:1 com
// `features/organization/batch-characteristics/hooks.ts`). Derivados do contrato, nunca redeclarados.
import type { BatchCharacteristicKind } from "@opus-dt/shared-types";

export type {
  BatchCharacteristicKind,
  BatchCharacteristicRequest,
  BatchCharacteristicResponse,
  BatchCharacteristicUpdate,
  BatchCharacteristicValueInput,
} from "@opus-dt/shared-types";

/** O rascunho enquanto o gestor declara a característica — antes de virar pedido. */
export interface BatchCharacteristicDraft {
  id: string | null;
  name: string;
  kind: BatchCharacteristicKind;
  required: boolean;
  lineIds: string[];
  values: Array<{ id?: string; label: string }>;
}

export const BATCH_CHARACTERISTIC_DRAFT_VAZIO: BatchCharacteristicDraft = {
  id: null,
  name: "",
  kind: "LIST",
  required: false,
  lineIds: [],
  values: [{ label: "" }],
};
